import React from 'react';
import { EntityPanelTab } from '../../../../panels/entity-panels/tabs/entity-panel-tab';
import { useSetActiveBoloPanelTab } from '../../state/active-bolo-panel-tab-provider';

export const BoloPanelTab = (props: {
    title: string;
    children: React.ReactNode;
    titleTrailingNode?: React.ReactNode;
}): React.ReactElement => {
    const setActiveBoloPanelTab = useSetActiveBoloPanelTab();
    return (
        <EntityPanelTab
            {...props}
            errorBoundaryName="BOLO_PANEL_TAB"
            onClose={() => setActiveBoloPanelTab(undefined)}
            testId="BOLO_PANEL_TAB"
        >
            {props.children}
        </EntityPanelTab>
    );
};
